import React from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import WrapperWithTabs from "../../components/WrapperWithTabs";
import { tabBarOptions } from "./tabBarOptions";
import { useAuth } from "../../contexts/AuthContext";

const MyAccount = () => {
  const { user } = useAuth();
  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="My Account"
        showBack={false}
        containerClassName="mt-14"
      />

      <WrapperWithTabs
        tabBarOptions={tabBarOptions}
        wrapperClassName="mt-6"
        componentBasedProps={{ 1: { profileData: user } }}
      />
    </div>
  );
};

export default MyAccount;
